import { Link } from 'react-router-dom'
import type { AssetCheckListItem } from '@/types/assetCheck'
import { VerdictBadge } from './VerdictBadge'

interface AssetCheckHistoryListProps {
  items: AssetCheckListItem[]
}

export function AssetCheckHistoryList({ items }: AssetCheckHistoryListProps) {
  if (items.length === 0) {
    return (
      <div
        className="rounded-lg border border-dashed border-slate-300 p-4 text-sm text-slate-500"
        data-testid="history-empty"
      >
        Noch keine Checks durchgeführt.
      </div>
    )
  }
  return (
    <div className="rounded-lg border border-slate-200 bg-white" data-testid="history-list">
      <table className="w-full text-sm">
        <thead className="bg-slate-50">
          <tr>
            <th className="text-left px-3 py-2 font-medium text-slate-600">Datum</th>
            <th className="text-left px-3 py-2 font-medium text-slate-600">ISIN</th>
            <th className="text-left px-3 py-2 font-medium text-slate-600">Asset</th>
            <th className="text-left px-3 py-2 font-medium text-slate-600">Verdict</th>
          </tr>
        </thead>
        <tbody>
          {items.map((i) => (
            <tr key={i.id} className="border-t border-slate-100 hover:bg-slate-50">
              <td className="px-3 py-2 text-slate-600">
                {new Date(i.created_at).toLocaleDateString('de-DE')}
              </td>
              <td className="px-3 py-2 font-mono text-slate-700">{i.isin}</td>
              <td className="px-3 py-2 text-slate-900">
                <Link
                  to={`/asset-check/${i.id}`}
                  className="hover:underline"
                  data-testid={`history-link-${i.id}`}
                >
                  {i.security_name}
                </Link>
              </td>
              <td className="px-3 py-2">
                <VerdictBadge verdict={i.verdict} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
